import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export default function Columns({ children, sideContent, theme }) {
  return (
    <div className={`${styles.columns} ${styles[theme]}`}>
      <div className={styles.aside}>
        <div className={styles.sideArea}>{sideContent}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.contentArea}>{children}</div>
      </div>
    </div>
  );
}

Columns.propTypes = {
  children: PropTypes.node,
  sideContent: PropTypes.node,
  theme: PropTypes.oneOf(['purple', 'red', 'blue'])
};
